import Vue from 'vue'
import Router from 'vue-router'
import Download from '@/components/Download'
import Privacy from '@/components/Privacy'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Router)
Vue.use(ElementUI)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Download',
      component: Download
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js